import React, { useEffect, useState } from 'react'
import {motion,useScroll } from 'framer-motion'

const Top = () => {
  const [scrolling,setScrolling] = useState(0)

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  useEffect(() => {
    function handleScroll() {
      setScrolling(window.scrollY);
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <motion.div
      className='my-3 to-top'
      whileHover={{ scale: 1.2 }}
      transition={{ type: "spring", stiffness: 400, damping: 10 }}
      onClick={() => toTop()}
      style={{ display: scrolling >= 700 ? "flex" : "none" }}
      >
      <i className="fa-solid fa-chevron-up"></i>
    </motion.div>
    
      
  )
}

export default Top